// extracted by mini-css-extract-plugin
module.exports = {"headerMenu":"headerMenu--3Y4MM","userMenu":"userMenu--2USHk"};